(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.cookieAcceptance = {
    attach: function () {

      /**
       * init function checks if user already has cookie, if they don't show them the alert for the cookies
       */
      (function init() {
        var currentCookies = document.cookie;

        if (currentCookies && currentCookies.indexOf('acceptedCookies') === -1) {
          showAlertForCookies();
        }
      })();

      /**
       * Gets the block for cookies, shows them and adds a click event to the close button
       */
      function showAlertForCookies() {
        var cookieAcceptanceBlock = document.querySelector('#block-cookieacceptanceblock');
        var cookieAcceptanceClose = document.querySelector('.block-cookie-acceptance-block__modal-close');

        if (cookieAcceptanceBlock) {
          cookieAcceptanceBlock.classList.add('show');
          cookieAcceptanceBlock.setAttribute('role', 'dialog');
          cookieAcceptanceBlock.setAttribute('aria-hidden', 'false');

          cookieAcceptanceClose.addEventListener('click', function (e) {
            e.preventDefault();
            saveAcceptedCookie();
            cookieAcceptanceBlock.classList.remove('show');
            cookieAcceptanceBlock.setAttribute('aria-hidden', 'true');
          });
        }
      }

      /**
       * Gets the current time, uses that to get 1 month from now, saves cookie that expires 1 month from now
       */
      function saveAcceptedCookie() {
        var monthInMiliseconds = 2592000000;
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + monthInMiliseconds;
        now.setTime(expireTime);
        document.cookie = 'acceptedCookies=true; expires=' + now.toGMTString();
      }
    }
  };

})(jQuery, Drupal, drupalSettings);
